"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ragogna": {
    "1b497bc8": [{
      "hkey": "c1665bed",
      "slug": "ragogna",
      "name": "Ragogna",
      "primary": true,
      "skipSearch": false
    }],
    "ca-farra": [{
      "hkey": "c1665bed",
      "slug": "ragogna",
      "name": "Ragogna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3df08f2e": [{
      "hkey": "c1665bed",
      "slug": "ragogna",
      "name": "Ragogna",
      "primary": true,
      "skipSearch": false
    }],
    "canodusso": [{
      "hkey": "c1665bed",
      "slug": "ragogna",
      "name": "Ragogna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "50432f11": [{
      "hkey": "c1665bed",
      "slug": "ragogna",
      "name": "Ragogna",
      "primary": true,
      "skipSearch": false
    }],
    "pignano": [{
      "hkey": "c1665bed",
      "slug": "ragogna",
      "name": "Ragogna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1bb79921": [{
      "hkey": "c1665bed",
      "slug": "ragogna",
      "name": "Ragogna",
      "primary": true,
      "skipSearch": false
    }],
    "villuzza": [{
      "hkey": "c1665bed",
      "slug": "ragogna",
      "name": "Ragogna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;